import { render, staticRenderFns } from "./AffinityGroupSelection.vue?vue&type=template&id=ded54e6c&scoped=true&"
import script from "./AffinityGroupSelection.vue?vue&type=script&lang=js&"
export * from "./AffinityGroupSelection.vue?vue&type=script&lang=js&"
import style0 from "./AffinityGroupSelection.vue?vue&type=style&index=0&id=ded54e6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded54e6c",
  null
  
)

export default component.exports